import React from "react";
import { useNavigate } from "react-router-dom";

import telegram from "assets/images/telegram.svg";
import twitter from "assets/images/twitter.svg";
import icon from "assets/images/icon.svg";
import discord from "assets/images/discord-img.svg";
import reddit from "assets/images/reddit.svg";
import medium from "assets/images/medium.svg";
import { HERO_SECTION } from "src/constants/images";
import { MARKET_PLACE } from "src/constants/routes";

const HeroSection = () => {
  const navigate = useNavigate();

  const redirectHandler = () => {
    navigate(MARKET_PLACE.INDEX);
  };
  const redirectHandlerEmerald = () => {
    window.open("https://emerald.gangstabet.io/", "_blank");
  };

  return (
    <div className="hero-section-container">
      <div className="hero-section container">
        <div className="text-container position-relative">
          {/* <p
            className="pre-sale-text text-center"
            onClick={() => navigate("/register")}
          >
            Reserve GangstaBets before we sell out!
          </p> */}

          <p className="para-title text-center">
            GangstaBet is a collection of 5,555 unique Gangsters & Detectives on the ICON blockchain
          </p>
          <p className="title text-center">Digital Collectible of the Future</p>
          <p className="first-paragraph text-center">
            GangstaBet is a digital collectible where people can evolve their characters for an eventual permanence on the ICON blockchain. Every character has a unique appearance, name and varying properties like classes & skills. GangstaBet takes a unique approach to distribute GangstaBetToken ($GBET) to its holders on a daily basis. The token can be used to change the name and skills of the GangstaBets. The supply of $GBET will decrease periodically and it will stop after 9 years.
          </p>
          <p className="second-paragraph text-center">
            As Gangstaverse grows, one day all of the 5,555 GangstaBets will be engraved in the blockchain with their character profiles for the future generations to behold.</p>
        </div>
        <div className="button-container">
          {/* <div className="d-flex align-center">
            <button
              className="btn btn-primary wallet-button my-2 "
              onClick={() => {
                window.open("https://docs.gangstaverse.co/");
              }}
            >
              Visit Docs
            </button>
            <button
              className="btn btn-primary wallet-button my-2 mx-3"
              onClick={redirectHandler}
            >
              Explore Marketplace
            </button>
          </div> */}

          <p className="text-center">Join our Community on</p>
          <div className="icon-container px-xs-3 pb-3">
            <a target="_blank" href="https://twitter.com/GangstaVerse">
              <img
                src={twitter}
                alt="twitter"
                className="me-3 twitter"
                style={{ color: "red" }}
              />
            </a>
            <a target="_blank" href="https://discord.gg/rkJBeAgQux">
              <img src={discord} alt="discord" className="me-3 discord" />
            </a>

            {/* <a target="_blank" href="https://t.me/gangstaverse">
              <img src={telegram} alt="telegram" className="me-3 telegram" />
            </a>
            <a target="_blank" href="https://icon.foundation/">
              <img src={icon} alt="icon" className="me-3 icon" />
            </a> */}
            <a target="_blank" href="https://gangstaverse.medium.com/">
              <img src={medium} alt="medium" className="me-3 medium" />
            </a>
          </div>
        </div>
        <div>
          <div className="hero-image position-relative">
            <img src={HERO_SECTION.SOURCE} alt="hero section" />
            {/* <p className="hero-text">
              GangstaBets last forever,{" "}
              <a href="#how-it-works">
                <span>How?</span>
              </a>
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
